<section class="py-5 bg-primary text-primary-foreground home-sections">
  <div class="container container-max">
    <ul class="breadcrumbs">
      <li class="text-primary-foreground opacity-60p"><a [routerLink]="''">Home</a></li>
      <li class="text-primary-foreground">Global Standards</li>
    </ul>
  </div>
</section>
<bor-global-standards-section [isPage]="true" />
<!--<section class="container pb-4 mb-5">-->
<!--  <div class="card p-0">-->
<!--    <div class="card-body border-bottom">-->
<!--      <h1 class="card-title">Beneficial Ownership Register (BOR) Standards</h1>-->
<!--    </div>-->
<!--    <div class="card-body">-->
<!--      <p class="pb-3">The <strong>Corporate Affairs Commission</strong> as the Registry of Companies in Nigeria is hosting the Beneficial Ownership Register which in our legal framework is referred to as Register of <strong>Persons with Significant Control (PSC)</strong>.</p>-->

<!--      <p class="pb-3">The <strong><a style="text-decoration-skip-ink: none !important;" class="text-success text-decoration-underline" href="https://icrp.cac.gov.ng/assets/docs/CAMA-NOTE%20FINAL-FULL-VERSION.pdf" target="_blank">Companies and Allied Matters Act, (CAMA), 2020</a></strong> has provided the legal framework for beneficial ownership information disclosure in Nigeria.</p>-->

<!--      <p class="pb-3">The implementation of the new legal regime has warranted the design, development and deployment of an electronic filing system that will accommodate information on persons with significant control in registered entities.</p>-->

<!--      <p class="pb-3">The threshold for disclosure is put at 5% minimum in terms of shareholding, interest, voting rights, right to appoint/remove Directors or any significant influence or control over a registered entity. The quantum of powers to be held or exercised for this purpose can be directly or indirectly.</p>-->

<!--      <p class="pb-3">The disclosure required under this legal framework is focused on the natural person who is the ultimate beneficial owner in an entity.</p>-->

<!--      <p class="pb-3">This Register of persons with significant control (PSC) provides the interface for reliable, effective and productive disclosure framework for new registrations and post-registration activities in line with global best practices.</p>-->
<!--    </div>-->
<!--  </div>-->
<!--</section>-->
